var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommonPageName, ERRORTYPE } from '../global';
import { GlobalHelper, HttpAuthTokenHelper, IsNullOrEmpty } from '.';
/// ******************************
/// This class contains methods to check
/// - authorisation
/// - authentication
/// - any redirection logic
/// this may be extended with any other method
/// the only constraint is to handle the stopProcess boolean
/// as it's used to implement a very siplified way for Chain Of Responsibility
export class SecureRouteHelper {
    constructor(to, from, next, toastStore) {
        this.toRoute = to;
        this.fromRoute = from;
        this.nextNavigation = next;
        this.toast = toastStore;
        this.stopProcess = false;
    }
    isAuthenticatedWithoutRedirect(user, canReconnect = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stopProcess) {
                return false;
            }
            const token = HttpAuthTokenHelper.getAccessTokenFromLocalStorage();
            if (!canReconnect && HttpAuthTokenHelper.isExpired(token) || (canReconnect && HttpAuthTokenHelper.isExpiredSinceOneHour(token))) {
                return false;
            }
            user.initUserConnectedFromToken(canReconnect);
            return true;
        });
    }
    isAuthenticated(onSuccessAction, pathToRedirectToOnFail, withRedirectionOnSuccess = true, withRedirectionOnFail = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stopProcess) {
                return false;
            }
            const token = HttpAuthTokenHelper.getAccessTokenFromLocalStorage();
            if (!HttpAuthTokenHelper.isExpired(token)) {
                return this.handleSuccess(onSuccessAction, token, withRedirectionOnSuccess);
            }
            return this.handleFailure("Votre session a expiré! Merci de renouveler votre session", pathToRedirectToOnFail, withRedirectionOnFail);
        });
    }
    isAuthorized(onSuccessAction, pathToRedirectToOnFail, withRedirectionOnSuccess = true, withRedirectionOnFail = true, currentDomain = '' // only needed on localhost
    ) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stopProcess) {
                return false;
            }
            const token = HttpAuthTokenHelper.getAccessTokenFromLocalStorage();
            const realDomain = IsNullOrEmpty(currentDomain) ? GlobalHelper.getRealDomain() : currentDomain;
            if (HttpAuthTokenHelper.isTokenValidForScope(token, realDomain)) {
                return this.handleSuccess(onSuccessAction, token, withRedirectionOnSuccess);
            }
            return this.handleFailure("Vous n'avez pas le droit d'accèder à cet espace! Merci d'utiliser un autre compte", pathToRedirectToOnFail, withRedirectionOnFail);
        });
    }
    handleSuccess(onSuccessAction, token, withRedirection) {
        if (onSuccessAction) {
            onSuccessAction(token, this.nextNavigation);
        }
        if (withRedirection) {
            this.nextNavigation();
        }
        return true;
    }
    handleFailure(message, pathToRedirectToOnFail, withRedirection) {
        var _a, _b, _c;
        this.stopProcess = true;
        if (CommonPageName.Login === ((_a = this.fromRoute) === null || _a === void 0 ? void 0 : _a.path) || CommonPageName.Login === ((_b = this.toRoute) === null || _b === void 0 ? void 0 : _b.path)) {
            (_c = this.toast) === null || _c === void 0 ? void 0 : _c.createAndPushToast('Unauthorized', message, false, ERRORTYPE.DANGER);
        }
        else if (withRedirection) {
            this.navigateTo(pathToRedirectToOnFail, this.toRoute, this.nextNavigation);
        }
        return false;
    }
    navigateTo(path, from, next) {
        if (IsNullOrEmpty(path))
            return next(CommonPageName.NotFound);
        if (from.path === path)
            return next();
        next(path);
    }
}
